export default __webpack_public_path__ + "static/media/T-60DAYS.6f194f0f.svg";